import { DatePicker } from '@mui/x-date-pickers';
import type { Dayjs } from 'date';
import { useState } from 'react';

import type { SelectDatePickerProps } from '../SelectDatePicker/SelectDatePicker';

export type DateRange = {
  from: Dayjs;
  to: Dayjs;
};

export interface DateRangeProps {
  onChange: SelectDatePickerProps['onChange'];
  onAccept?: () => void;
  defaultValues: DateRange;
}

export const DateRangePicker = ({ onChange, onAccept, defaultValues }: DateRangeProps) => {
  const [from, setFrom] = useState<Dayjs>(defaultValues.from);
  const [to, setTo] = useState<Dayjs>(defaultValues.to);

  return (
    <>
      <DatePicker
        format="DD/MM/YYYY"
        label="From"
        value={from}
        sx={{
          mr: 1,
        }}
        slotProps={{
          day: {
            onClick: (event) => {
              event.stopPropagation();
            },
          },
          openPickerButton: {
            // @ts-expect-error - data-testid is a valid prop, despite not being in the type
            'data-testid': 'from-picker-button',
          },
          textField: {
            id: 'date-picker',
            onClick: (event) => {
              event.stopPropagation();
            },
            size: 'small',
          },
        }}
        onAccept={onAccept}
        onChange={(date) => {
          if (!date) {
            return;
          }
          setFrom(date);
          onChange({
            from: date,
            to: to,
          });
        }}
      />
      <DatePicker
        format="DD/MM/YYYY"
        date-testid="to-date-picker"
        label="To"
        value={to}
        slotProps={{
          day: {
            onClick: (event) => {
              event.stopPropagation();
            },
          },
          openPickerButton: {
            // @ts-expect-error - data-testid is a valid prop, despite not being in the type
            'data-testid': 'to-picker-button',
          },
          textField: {
            onClick: (event) => {
              event.stopPropagation();
            },
            size: 'small',
          },
        }}
        onAccept={onAccept}
        onChange={(date) => {
          if (!date) {
            return;
          }
          setTo(date);
          onChange({
            from: from,
            to: date,
          });
        }}
      />
    </>
  );
};
